import { render, staticRenderFns } from "./CompanyCertificates.vue?vue&type=template&id=7ddcbf94&scoped=true&"
import script from "./CompanyCertificates.vue?vue&type=script&lang=js&"
export * from "./CompanyCertificates.vue?vue&type=script&lang=js&"
import style0 from "./CompanyCertificates.vue?vue&type=style&index=0&id=7ddcbf94&lang=scss&scoped=true&"
import style1 from "./CompanyCertificates.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddcbf94",
  null
  
)

export default component.exports